/* Password preview toggle */
$(document).on('click', '.password-field__toggle', function () {
	var $toggle = $(this);
	var $input = $toggle.siblings('input');
	if ($input.attr('type') === 'password') {
		$input.attr('type', 'text');
		$toggle.addClass('password-field__toggle--visible');
	} else {
		$input.attr('type', 'password');
		$toggle.removeClass('password-field__toggle--visible');
	}
});
